// ===== COMUNICACIÓN CON REACT NATIVE =====
export enum AppMessageType {
  // Mensajes que envía la WebView a React Native
  LOGOUT_REQUEST = 'LOGOUT_REQUEST',
  PQRS_CREATED = 'PQRS_CREATED',
  UNAUTHORIZED = 'UNAUTHORIZED',
  BACK_NATIVE = 'BACK_NATIVE',
  DOWNLOAD_FILE = 'DOWNLOAD_FILE'
}

export interface AppMessage {
  type: AppMessageType;
  payload?: any;
  timestamp?: string;
}

// ===== DATOS PARA DESCARGA DE ARCHIVOS =====
export interface DownloadFileData {
  url: string;
  fileName: string;
  fileType: string;
  fileSize: number;
}

// ===== RUTAS DE ACCESO =====
export enum AccessRoute {
  HOME = 'home',
  CREATE_PQRS = 'create-pqrs'
}

// ===== DECLARACIONES GLOBALES =====
declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void;
      onMessage?: (data: string) => void;
    };
  }
}